import ReadOnlyRecipientViewState from 'owa-readonly-recipient-well/lib/store/schema/ReadOnlyRecipientViewState';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import ItemId from 'owa-service/lib/contract/ItemId';
import getFromAddressWrapper from './fromAddressUtils/getFromAddressWrapper';

export default function createFromRecipientWell(
    fromAddress?: EmailAddressWrapper,
    referenceItemId?: ItemId
): ReadOnlyRecipientViewState {
    return { email: fromAddress ? fromAddress : getFromAddressWrapper(referenceItemId) };
}
